import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import type { Dispatch } from '../../../../types';
import { setMapCenter } from '../../../actions/mapActions';
import { AddressSearch, type IEvent } from '../../common/addressSearch/AddressSearch';
import { mapStateToProps } from './CircleFormAddressSearchContainer';
import { mapToPosition } from './utils/hereMapHelper';

export const mapDispatchToProps = (dispatch: Dispatch) => {
    const onChange = (event: IEvent | null) =>
        event && dispatch(setMapCenter(mapToPosition(event.latitude, event.longitude)));

    return {
        onChange,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AddressSearch));
